<template>
  <v-card flat>
    <v-card-text>
      <v-row v-if="['other_form', 'paper_form'].includes(manifest.manifest_type) ">
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ numeric: true, length: 11 }"
            name="マニフェスト番号"
          >
            <v-text-field
              v-model="manifestDraft.manifest_no"
              :disabled="!canEdit"
              :error-messages="errors"
              dense
              label="マニフェスト番号"
              hide-details="auto"
              outlined
              persistent-hint
              persistent-placeholder
            >
              <template v-slot:label>
                <span>マニフェスト番号</span>
                <span class="ml-1">
                  ({{ manifestDraft.manifest_no?.length || 0 }} / 11)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <cs-date-picker
            :date.sync="manifestDraft.collected_date"
            :disabled="!canEdit"
            :maximum-date="maximumDate"
            @dateChangedCallback="(date) => { manifestDraft.collected_date = date }"
          >
            <template v-slot="{ on, attrs }">
              <validation-provider
                v-slot="{ errors }"

                class="requiredMark"
                name="引渡し日"
                rules="required"
              >
                <v-text-field
                  v-model="manifestDraft.collected_date"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!canEdit"
                  :error-messages="errors"
                  append-icon="mdi-calendar"
                  clearable
                  dense
                  hide-details="auto"
                  label="引渡し日"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  readonly
                >
                </v-text-field>
              </validation-provider>
            </template>
          </cs-date-picker>
          <validation-provider
            v-if="false"
            v-slot="{ errors }"
            class="requiredMark"
            name="引渡し日"
            rules="required"
          >
            <vue-ctk-date-time-picker
              v-model="manifestDraft.collected_date"
              :disabled="!canEdit"
              :max-date="maximumDate"
              no-value-to-custom-elem
              only-date
              no-button
              no-header
              auto-close
              color="#0070B3"
              format="YYYY-MM-DD"
              formatted="YYYY-MM-DD"
            >
              <v-text-field
                v-model="manifestDraft.collected_date"
                :disabled="!canEdit"
                :error-messages="errors"
                append-icon="mdi-calendar"
                clearable
                dense
                hide-details="auto"
                label="引渡し日"
                outlined
                persistent-hint
                persistent-placeholder
                readonly
              />
            </vue-ctk-date-time-picker>
          </validation-provider>
        </v-col>
        <v-col
          v-if="canEdit"
          cols="12"
          md="4"
        >
          <validation-provider
            v-slot="{ errors }"
            :class="['dxe_form', 'transfer_form'].includes(manifest.manifest_type) ? 'requiredMark' : '' "
            :rules="{ required: ['dxe_form', 'transfer_form'].includes(manifest.manifest_type), max: 12 }"
            name="引渡担当者"
          >
            <v-combobox
              v-model="manifestDraft.deliver_staff"
              :error-messages="errors"
              :items="deliverers"
              :return-object="false"
              dense
              label="引渡担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>引渡担当者</span>
                <span class="ml-1">
                  ({{ manifestDraft.deliver_staff?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>
        </v-col>
        <v-col
          v-else
          cols="12"
          md="4"
        >
          <validation-provider
            v-slot="{ errors }"
            :class="['dxe_form', 'transfer_form'].includes(manifest.manifest_type) ? 'requiredMark' : '' "
            name="引渡担当者"
          >
            <v-text-field
              v-model="manifestDraft.deliver_staff"
              :error-messages="errors"
              disabled
              dense
              label="引渡担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>引渡担当者</span>
                <span class="ml-1">
                  ({{ manifestDraft.deliver_staff?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col
          v-if="canEdit"
          cols="12"
          md="4"
        >
          <validation-provider
            v-slot="{ errors }"
            :vid="`register_staff`"
            name="登録担当者"
            rules="max:12"
          >
            <v-combobox
              v-model="manifestDraft.register_staff"
              :error-messages="errors"
              :items="registers"
              :return-object="false"
              dense
              label="登録担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>登録担当者</span>
                <span class="ml-1">
                  ({{ manifestDraft.register_staff?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>
        </v-col>
        <v-col
          v-else
          cols="12"
          md="4"
        >
          <validation-provider
            v-slot="{ errors }"
            name="登録担当者"
          >
            <v-text-field
              v-model="manifestDraft.register_staff"
              :error-messages="errors"
              disabled
              dense
              label="登録担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>登録担当者</span>
                <span class="ml-1">
                  ({{ manifestDraft.register_staff?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>

      <!-- 連絡番号 -->
      <v-row>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="連絡番号１"
            rules="contact_num_only|max:20"
          >
            <v-text-field
              v-model="manifestDraft.contact_number_1"
              :disabled="!canEdit"
              :error-messages="errors"
              dense
              label="連絡番号１"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>連絡番号１</span>
                <span class="ml-1">
                  ({{ manifestDraft.contact_number_1?.length || 0 }} / 20)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="連絡番号２"
            rules="contact_num_only|max:20"
          >
            <v-text-field
              v-model="manifestDraft.contact_number_2"
              :disabled="!canEdit"
              :error-messages="errors"
              dense
              label="連絡番号２"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>連絡番号２</span>
                <span class="ml-1">
                  ({{ manifestDraft.contact_number_2?.length || 0 }} / 20)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="連絡番号３"
            rules="contact_num_only|max:20"
          >
            <v-text-field
              v-model="manifestDraft.contact_number_3"
              :disabled="!canEdit"
              :error-messages="errors"
              dense
              label="連絡番号３"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>連絡番号３</span>
                <span class="ml-1">
                  ({{ manifestDraft.contact_number_3?.length || 0 }} / 20)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>

      <!-- 取扱品目／廃棄物の名称 -->
      <v-row>
        <v-col
          v-if="canEdit"
          cols="12"
          md="6"
        >
          <validation-provider
            v-slot="{ errors }"
            class="requiredMark"
            name="取扱品目"
            rules="required"
          >
            <item-autocomplete
              v-model="manifestDraft.item_id"
              :items="items"
              :error-messages="errors"
              label="取扱品目"
              clearable
              dense
              hide-details="auto"
              outlined
              persistent-placeholder
              placeholder="品目名で検索する"
              @change="itemChangeEvent"
            />
          </validation-provider>
        </v-col>
        <v-col
          v-else
          cols="12"
          md="6"
        >
          <validation-provider
            v-slot="{ errors }"
            class="requiredMark"
            name="取扱品目"
          >
            <v-text-field
              v-model="manifestDraft.item_code_name"
              :error-messages="errors"
              disabled
              dense
              label="取扱品目"
              hide-details="auto"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            name="廃棄物の名称"
            rules="max:30"
          >
            <v-text-field
              v-model="manifestDraft.waste_name"
              :error-messages="errors"
              :disabled="!canEdit"
              dense
              hide-details="auto"
              label="廃棄物の名称"
              outlined
              persistent-placeholder
            >
             <template v-slot:label>
                <span>廃棄物の名称</span>
                <span class="ml-1">
                  ({{ manifestDraft.waste_name?.length || 0 }} / 30)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /取扱品目／廃棄物の名称 -->

      <!-- 数量／数量単位／数量の確定者-->
      <v-row>
        <v-col cols="12" md="3">
          <validation-provider
            v-slot="{ errors }"
            :class="(['dxe_form', 'transfer_form'].includes(manifest.manifest_type) && manifestDraft.quantity_confirm_id === 2) || manifestDraft.quantity_unit_id > 0 ? 'requiredMark' : ''"
            :custom-messages="customMessages"
            :rules="{
              required: (['dxe_form', 'transfer_form'].includes(manifest.manifest_type) && manifestDraft.quantity_confirm_id === 2) || manifestDraft.quantity_unit_id > 0,
              double: true,
              min_value: 0.001,
              max_value: 99999.999,
              quantityWithDecimal: { int_digits: 5, dec_digits: 3 }
            }"
            name="数量"
          >
            <v-text-field
              v-model="manifestDraft.quantity"
              :error-messages="errors"
              :disabled="!canEdit"
              :show-size="1000"
              dense
              label="数量"
              hide-details="auto"
              outlined
              persistent-placeholder
              reverse
              type="number"
              @keydown.69.prevent
            />
          </validation-provider>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <validation-provider
            v-slot="{ errors }"
            :class="(['dxe_form', 'transfer_form'].includes(manifest.manifest_type) && manifestDraft.quantity_confirm_id === 2) || manifestDraft.quantity > 0 ? 'requiredMark' : ''"
            :rules="{ required: (['dxe_form', 'transfer_form'].includes(manifest.manifest_type) && manifestDraft.quantity_confirm_id === 2) || manifestDraft.quantity > 0 }"
            name="数量単位"
          >
            <v-select
              v-model="manifestDraft.quantity_unit_id"
              :disabled="!canEdit"
              :error-messages="errors"
              :items="quantityUnits"
              clearable
              dense
              hide-details="auto"
              label="数量単位"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="5">
          <validation-provider
            v-slot="{ errors }"
            :class="['dxe_form', 'transfer_form'].includes(manifest.manifest_type) ? 'requiredMark' : '' "
            :rules="{ required: ['dxe_form', 'transfer_form'].includes(manifest.manifest_type) }"
            name="数量の確定者"
          >
            <v-select
              v-model="manifestDraft.quantity_confirm_id"
              :error-messages="errors"
              :disabled="!canEdit"
              :items="quantityConfirms"
              clearable
              dense
              hide-details="auto"
              label="数量の確定者"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /数量／数量単位／数量の確定者-->

      <!-- 荷姿／荷姿数量 -->
      <v-row>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            :class="['dxe_form', 'transfer_form'].includes(manifest.manifest_type) ? 'requiredMark' : ''"
            :rules="{ required: ['dxe_form', 'transfer_form'].includes(manifest.manifest_type) }"
            name="荷姿"
          >
            <v-select
              v-model="manifestDraft.packing_id"
              :error-messages="errors"
              :disabled="!canEdit"
              :items="packings"
              clearable
              dense
              hide-details="auto"
              label="荷姿"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
            name="荷姿の数量"
          >
            <v-text-field
              v-model="manifestDraft.packing_quantity"
              :error-messages="errors"
              :disabled="!canEdit"
              dense
              hide-details="auto"
              label="荷姿の数量"
              outlined
              reverse
              persistent-placeholder
              type="number"
              @keydown.69.prevent
            />
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /荷姿／荷姿数量 -->

      <!-- 有害物質 -->
      <v-row>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            :rules="{
              duplicateKeys: { keys: [
                manifestDraft.hazardous_substance_2_id,
                manifestDraft.hazardous_substance_3_id,
                manifestDraft.hazardous_substance_4_id,
                manifestDraft.hazardous_substance_5_id,
                manifestDraft.hazardous_substance_6_id
              ] }
            }"
            name="有害物質1"
          >
            <v-select
              v-model="manifestDraft.hazardous_substance_1_id"
              :disabled="disableHazardousSubstance"
              :error-messages="errors"
              :items="hazardousSubstances"
              clearable
              dense
              hide-details="auto"
              label="有害物質１"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            :rules="{
              duplicateKeys: { keys: [
                manifestDraft.hazardous_substance_1_id,
                manifestDraft.hazardous_substance_3_id,
                manifestDraft.hazardous_substance_4_id,
                manifestDraft.hazardous_substance_5_id,
                manifestDraft.hazardous_substance_6_id
              ] }
            }"
            name="有害物質2"
          >
            <v-select
              v-model="manifestDraft.hazardous_substance_2_id"
              :disabled="disableHazardousSubstance"
              :error-messages="errors"
              :items="hazardousSubstances"
              clearable
              dense
              hide-details="auto"
              label="有害物質２"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            :rules="{
              duplicateKeys: { keys: [
                manifestDraft.hazardous_substance_1_id,
                manifestDraft.hazardous_substance_2_id,
                manifestDraft.hazardous_substance_4_id,
                manifestDraft.hazardous_substance_5_id,
                manifestDraft.hazardous_substance_6_id
              ] }
            }"
            name="有害物質3"
          >
            <v-select
              v-model="manifestDraft.hazardous_substance_3_id"
              :disabled="disableHazardousSubstance"
              :error-messages="errors"
              :items="hazardousSubstances"
              clearable
              dense
              hide-details="auto"
              label="有害物質３"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            :rules="{
              duplicateKeys: { keys: [
                manifestDraft.hazardous_substance_1_id,
                manifestDraft.hazardous_substance_2_id,
                manifestDraft.hazardous_substance_3_id,
                manifestDraft.hazardous_substance_5_id,
                manifestDraft.hazardous_substance_6_id
              ] }
            }"
            name="有害物質4"
          >
            <v-select
              v-model="manifestDraft.hazardous_substance_4_id"
              :disabled="disableHazardousSubstance"
              :error-messages="errors"
              :items="hazardousSubstances"
              clearable
              dense
              hide-details="auto"
              label="有害物質４"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            :rules="{
              duplicateKeys: { keys: [
                manifestDraft.hazardous_substance_1_id,
                manifestDraft.hazardous_substance_2_id,
                manifestDraft.hazardous_substance_3_id,
                manifestDraft.hazardous_substance_4_id,
                manifestDraft.hazardous_substance_6_id
              ] }
            }"
            name="有害物質5"
          >
            <v-select
              v-model="manifestDraft.hazardous_substance_5_id"
              :disabled="disableHazardousSubstance"
              :error-messages="errors"
              :items="hazardousSubstances"
              clearable
              dense
              hide-details="auto"
              label="有害物質５"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            :rules="{
              duplicateKeys: { keys: [
                manifestDraft.hazardous_substance_1_id,
                manifestDraft.hazardous_substance_2_id,
                manifestDraft.hazardous_substance_3_id,
                manifestDraft.hazardous_substance_4_id,
                manifestDraft.hazardous_substance_5_id
              ] }
            }"
            name="有害物質6"
          >
            <v-select
              v-model="manifestDraft.hazardous_substance_6_id"
              :disabled="disableHazardousSubstance"
              :error-messages="errors"
              :items="hazardousSubstances"
              clearable
              dense
              label="有害物質６"
              hide-details="auto"
              outlined
              persistent-placeholder
            />
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /有害物質 -->

      <!-- 運搬方法／処分方法-->
      <v-row>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="運搬方法"
          >
            <v-select
              v-model="manifestDraft.transportation_id"
              :items="transportations"
              :error-messages="errors"
              :disabled="!canEdit"
              clearable
              dense
              hide-details="auto"
              label="運搬方法"
              outlined
              persistent-placeholder
            ></v-select>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="処分方法"
          >
            <v-select
              v-model="manifestDraft.disposal_method_id"
              :items="disposalMethods"
              :error-messages="errors"
              :disabled="!canEdit"
              clearable
              dense
              hide-details="auto"
              label="処分方法"
              outlined
              persistent-placeholder
            ></v-select>
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /運搬方法／処分方法-->

      <!-- 運搬担当者・車両番号 -->
      <v-row>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ max: 12 }"
            name="運搬担当者"
          >
            <v-combobox
              v-model="manifestDraft.transport_user_name"
              :disabled="!canEdit"
              :error-messages="errors"
              :items="drivers"
              :return-object="false"
              :clearable="true"
              dense
              label="運搬担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>運搬担当者</span>
                <span class="ml-1">
                  ({{ manifestDraft.transport_user_name?.length || 0 }} / 12)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>

        </v-col>
        <v-col cols="12" md="6">
          <validation-provider
            v-slot="{ errors }"
            name="車両番号"
            rules="max:15"
          >
            <v-combobox
              v-model="manifestDraft.vehicle_number"
              :disabled="!canEdit"
              :error-messages="errors"
              :clearable="true"
              :items="vehicles"
              :return-object="false"
              item-text="number"
              item-value="number"
              dense
              label="車両番号"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>車両番号</span>
                <span class="ml-1">
                  ({{ manifestDraft.vehicle_number?.length || 0 }} / 15)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>

        </v-col>

      </v-row>
      <!-- /運搬担当者・車両番号 -->

      <!-- 備考 -->
      <v-row>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="備考１"
            rules="max:25"
          >
            <v-text-field
              v-model="manifestDraft.note_1"
              :error-messages="errors"
              :disabled="!canEdit"
              dense
              hide-details="auto"
              label="備考１"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>備考１</span>
                <span class="ml-1">
                  ({{ manifestDraft.note_1?.length || 0 }} / 25)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="備考２"
            rules="max:25"
          >
            <v-text-field
              v-model="manifestDraft.note_2"
              :error-messages="errors"
              :disabled="!canEdit"
              dense
              hide-details="auto"
              label="備考２"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>備考２</span>
                <span class="ml-1">
                  ({{ manifestDraft.note_2?.length || 0 }} / 25)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="備考３"
            rules="max:25"
          >
            <v-text-field
              v-model="manifestDraft.note_3"
              :error-messages="errors"
              :disabled="!canEdit"
              dense
              hide-details="auto"
              label="備考３"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>備考３</span>
                <span class="ml-1">
                  ({{ manifestDraft.note_3?.length || 0 }} / 25)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="備考４"
            rules="max:25"
          >
            <v-text-field
              v-model="manifestDraft.note_4"
              :error-messages="errors"
              :disabled="!canEdit"
              dense
              hide-details="auto"
              label="備考４"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>備考４</span>
                <span class="ml-1">
                  ({{ manifestDraft.note_4?.length || 0 }} / 25)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12" md="4">
          <validation-provider
            v-slot="{ errors }"
            name="備考５"
            rules="max:25"
          >
            <v-text-field
              v-model="manifestDraft.note_5"
              :error-messages="errors"
              :disabled="!canEdit"
              dense
              hide-details="auto"
              label="備考５"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>備考５</span>
                <span class="ml-1">
                  ({{ manifestDraft.note_5?.length || 0 }} / 25)
                </span>
              </template>
              <template v-slot:counter></template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <!-- /備考 -->

    </v-card-text>
  </v-card>
</template>

<script>
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";

export default {
  name: 'ModifyManifestReportForm',
  components: {
    ItemAutocomplete,
  },
  mixins: [],
  props: {
    manifest: {
      type: Object,
      default: () => null,
    },
    manifestDraft: {
      type: Object,
      default: () => {},
    },
    manifestDraftTransport: {
      type: Object,
      default: () => {},
    },
    manifestDisposal: {
      type: Object,
      default: () => {},
    },
    deliverers: {
      type: Array,
      default: () => [],
    },
    registers: {
      type: Array,
      default: () => []
    },
    quantityUnits: {
      type: Array,
      default: () => []
    },
    quantityConfirms: {
      type: Array,
      default: () => [],
    },
    hazardousSubstances: {
      type: Array,
      default: () => []
    },
    packings: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    disposalMethods: {
      type: Array,
      default: () => [],
    },
    transportations: {
      type: Array,
      default: () => [],
    },
    drivers: {
      type: Array,
      default: () => [],
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      disableHazardousSubstance: true,
      customMessages: {
        double: '数量は半角数字のみ使用できます'
      },
    }
  },
  computed: {
    maximumDate () {
      if (this.manifestDraftTransport) {
        if (this.manifestDraftTransport.report_transport_completed_date) {
          if (this.manifestDisposal.disposal_report_end_date) {
            if (this.manifestDraftTransport.report_transport_completed_date <= this.manifestDisposal.disposal_report_end_date) {
              return this.manifestDraftTransport.report_transport_completed_date
            } else {
              return this.manifestDisposal.disposal_report_end_date
            }
          } else {
            return this.manifestDraftTransport.report_transport_completed_date
          }
        } else {
          if (this.manifestDisposal.disposal_report_end_date) {
            return this.manifestDisposal.disposal_report_end_date
          } else {
            return this.$dayjs().format("YYYY-MM-DD")
          }
        }
      } else {
        if (this.manifestDisposal.disposal_report_end_date) {
          return this.manifestDisposal.disposal_report_end_date
        } else {
          return this.$dayjs().format("YYYY-MM-DD")
        }
      }
    },
  },
  watch: {
    canEdit (newValue) {
      if (newValue) {
        this.itemChangeEvent()
      }
    },
  },
  created() {},
  methods: {
    removeHazardousSubstances () {
      this.manifestDraft.hazardous_substance_1_id = null
      this.manifestDraft.hazardous_substance_2_id = null
      this.manifestDraft.hazardous_substance_3_id = null
      this.manifestDraft.hazardous_substance_4_id = null
      this.manifestDraft.hazardous_substance_5_id = null
      this.manifestDraft.hazardous_substance_6_id = null
    },
    /**
     * 有害物質項目の表示制御
     */
    itemChangeEvent () {
      if (!this.canEdit) {
        return true
      }
      /**
       * @param {Object} item - 選択された品目
       * @param {boolean} item.use_harmful - 選択されたアイテムに付加された有害物質利用設定
       */
      let item = this.items.find( (v) => v.value === this.manifestDraft.item_id)
      if (item === undefined) {
        this.removeHazardousSubstances()
        return true
      }
      this.manifestDraft.item_type = item.type;

      if (!item.use_harmful) {
        this.removeHazardousSubstances()
      }
      this.disableHazardousSubstance = !item.use_harmful
    },
  }
}
</script>
